import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { GbsonderrechtService, GrundstueckId, SonderrechtMasterDetailEntryMeta } from '../../../../core/gb-api';
import { AppConfigService } from '../../../../core/services/app-config.service';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { HistoryMode } from '../../../../core/services/HistoryMode';
import { AbstractComponent } from '../../../components/abstract-component/abstract.component';
import { ListLoader } from '../../../components/list-loader/list-loader';
import { ListLoaderObservable } from '../../../components/list-loader/list-loader-observable';
import { BeschreibungTableWrapperComponent } from '../../../components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../../directives/history.directive';
import { RechtsgrundComponent } from '../../../kompaktdarstellung/rechtsgrund/rechtsgrund.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-sonderrecht',
  templateUrl: './sonderrecht.component.html',
  styleUrls: ['./sonderrecht.component.scss'],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    HistoryDirective,
    RechtsgrundComponent,
    TranslatePipe
  ]
})
export class SonderrechtComponent extends AbstractComponent implements OnChanges, OnDestroy {
  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<SonderrechtMasterDetailEntryMeta>;
  historischeDatenSubscription;

  @Input()
  anzeigenHistorischeDaten: boolean = true;
  @Input()
  tableFullWidth: boolean = false;
  @Input()
  hasRight: boolean = true;

  constructor(
    private sonderrechtService: GbsonderrechtService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService
  ) {
    super();
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  update(): void {
    const historischeDaten = this.anzeigenHistorischeDaten
      ? this.appConfigService.einstellungHistorischeDaten
      : HistoryMode.HistoryMode.OHNE_HIST;
    const timepointCtx = this.timepointService.timepointCtx;
    const observable = this.sonderrechtService.loadSonderrechtSichtGrundstueck(
      //
      this._grundstueckId.id, //
      timepointCtx.timepointIso, //
      timepointCtx.timepointId, //
      historischeDaten //
    );
    this.listLoader = new ListLoaderObservable<SonderrechtMasterDetailEntryMeta>(undefined, 1, observable);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }
}
